import request from '@/utils/request';

// 根据条件获取应用商品配置
export function getProductsConfig (filter) {
  return request.get('api/admin/pay-gear', filter);
}

// 获取所有应用商品配置
export function getProductsConfigAll () {
  return request.get('api/admin/pay-gear/all');
}

//添加应用商品配置
export function saveProductConfig (product) {
  return request.post('/api/admin/pay-gear', product);
}

// 修改应用商品配置
export function updateProductConfig (product) {
  return request.put('/api/admin/pay-gear/', product);
}

// 删除应用商品配置
export function deleteProductConfig (id) {
  return request.delete('/api/admin/pay-gear/', id);
}

// 一键上架
export function putAwayConfig () {
  return request.post('/api/admin/pay-gear/putaway');
}

// 一键下架
export function soldOutConfig () {
  return request.post('/api/admin/pay-gear/soldout');
}

// 清处应用商品缓存
export function deleteCache (appIndex) {
  return request.post('/api/admin/pay-gear/deletecache', {appIndex});
}



// WEBPACK FOOTER //
// ./src/api/appProducts.js